export const fileNameBuilder = (exportModuleName: string) => {
  const date = new Date();
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");
  const fileName = `${day}${month}${year}_${exportModuleName}`;
  return fileName;
};

export const losFileNameBuilder = (period: string, reportSuffix?: string) => {
  const date = new Date();
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");

  const suffix = reportSuffix ? `_${reportSuffix}` : "";

  return `${day}${month}${year}_${period}${suffix}`;
};
